// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"4f6a8ccc","808":"9f91d90d","857":"8fabe25d","884":"18aba9bf","922":"58cc0371"}[chunkId] + ".chunk.js";
};